import { gql } from '@apollo/client';

const UPDATE_STUDY_PATIENT_INFORMATION = gql`
  mutation updateStudyPatientInformation($input: UpdateStudyPatientInformationInput!) {
    updateStudyPatientInformation(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_STUDY_PATIENT_INFORMATION;
